import { useTranslation } from 'react-i18next';
import { ChatMessage } from '@stores';

interface ChatBadgeProps {
  message: ChatMessage;
};

export function ChatBadge({ message }: ChatBadgeProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Chat' });

  const isPremium = () => {
    return message.author?.premiumUntil && new Date(message.author.premiumUntil) >= new Date();
  };

  if (message.author?.role === 'ADMIN') return (
    <span className="text-black">{t('dev')}</span>
  );

  if (isPremium()) return (
    <span className="text-black">{t('premium')}</span>
  );

  return <span />;
}